import * as MyPOSEmbedded from 'mypos-embedded-checkout';
import React, { useEffect, useRef } from 'react';
import { IS_DEV } from '../../../shared/constants';
import { useGetMyPosSession } from '../hooks/useGetMyPosSession';

interface MyPosPayButtonProps {
    orderId: string;
    loyaltyId: number;
    orderAmount: number;
    merchantName: string;
    currencyCode: string;
    onPaymentCompleted: (response: Record<string, unknown>) => void;
    onError: (err?: unknown) => void;
    innerClassName?: string;
}

const MyPosPayButton = (props: MyPosPayButtonProps) => {
    const {
        orderId,
        loyaltyId,
        orderAmount,
        currencyCode,
        merchantName,
        innerClassName = '',
        onPaymentCompleted,
        onError,
    } = props;

    const { data: sessionData } = useGetMyPosSession(orderId, loyaltyId);
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (!sessionData?.sessiontoken || hasInitialized.current) return;
        hasInitialized.current = true;

        const sessionToken = sessionData.sessiontoken;

        if (MyPOSEmbedded.IS_APPLE_PAY_AVAILABLE) {
            MyPOSEmbedded.createApplePayButton(
                'embeddedButtons', //div tag ID
                sessionToken, //Received session token from IPCPaymentSessionCreate
                {
                    isSandbox: IS_DEV, //Is sandbox env
                    merchantName: merchantName, //Custom Merchant name
                    onSuccess: function (data: Record<string, unknown>) {
                        onPaymentCompleted(data);
                    },
                    onDecline: function (err: unknown) {
                        onError(err);
                    },
                },
            )
                .then(() => {
                    // button loaded
                })
                .catch((err: unknown) => {
                    console.error(err);
                    onError(err);
                });
        } else {
            MyPOSEmbedded.createGooglePayButton(
                'embeddedButtons', //div tag ID
                sessionToken, //Received session token from IPCPaymentSessionCreate
                {
                    isSandbox: IS_DEV, //Is sandbox env
                    onSuccess: function (data: Record<string, unknown>) {
                        onPaymentCompleted(data);
                    },
                    onDecline: function (err: unknown) {
                        console.error(err);
                        onError(err);
                    },
                },
            )
                .then(() => {
                    // button loaded
                })
                .catch((err: unknown) => {
                    console.error(err);
                    onError(err);
                });
        }
    }, [sessionData, merchantName, onPaymentCompleted, onError]);

    return <div id="embeddedButtons" />;
};

const MyPosPayButtonMemo = React.memo(MyPosPayButton);
export { MyPosPayButtonMemo as MyPosPayButton };
